(() => {
  "use strict";

  window.babiiniIsFullEmail = window.babiiniIsFullEmail || ((value) => {
    const email = String(value || "").trim();
    if (!email || email.length > 254 || email.includes("..")) return false;

    const parts = email.split("@");
    if (parts.length !== 2) return false;

    const [localPart, domain] = parts;
    if (!localPart || localPart.length > 64 || localPart.startsWith(".") || localPart.endsWith(".")) return false;
    if (!/^[^\s@]+$/.test(localPart)) return false;

    const labels = domain.toLowerCase().split(".");
    if (labels.length < 2) return false;
    if (labels.some((label) => !/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i.test(label))) return false;

    const topLevelDomain = labels.at(-1);
    return /^[a-z]{2,63}$/i.test(topLevelDomain) || /^xn--[a-z0-9-]{2,59}$/i.test(topLevelDomain);
  });

  const NEWSLETTER_SELECTOR = [
    "[data-newsletter-form]",
    ".site-footer-form",
    ".about-newsletter-form",
    ".pg-newsletter-form",
  ].join(",");

  const ensureHiddenField = (form, name, value) => {
    let field = form.querySelector(`input[name="${name}"]`);
    if (!field) {
      field = document.createElement("input");
      field.type = "hidden";
      field.name = name;
      form.prepend(field);
    }
    field.value = value;
  };

  const ensureStatus = (form) => {
    let status = form.querySelector("[data-newsletter-status]");
    if (!status && form.nextElementSibling?.matches("[data-newsletter-status]")) {
      status = form.nextElementSibling;
    }
    if (status) return status;

    status = document.createElement("p");
    status.className = "newsletter__status";
    status.dataset.newsletterStatus = "";
    status.setAttribute("role", "status");
    status.setAttribute("aria-live", "polite");
    status.hidden = true;
    form.insertAdjacentElement("afterend", status);
    return status;
  };

  const setupNewsletterForm = (form) => {
    if (form.dataset.asyncNewsletterReady === "true") return;
    if (form.matches("[data-promo-newsletter-form]")) return;

    const email = form.querySelector("input[type='email']");
    if (!email) return;

    const status = ensureStatus(form);
    const submit = form.querySelector("button[type='submit'], input[type='submit']");
    const root = window.Shopify?.routes?.root || "/";
    const contactUrl = `${root.endsWith("/") ? root : `${root}/`}contact`;

    form.dataset.asyncNewsletterReady = "true";
    form.dataset.nocaptcha = "true";
    form.method = "post";
    form.action = contactUrl;
    email.name = "contact[email]";
    ensureHiddenField(form, "form_type", "customer");
    ensureHiddenField(form, "utf8", "✓");
    ensureHiddenField(form, "contact[tags]", "newsletter");

    email.addEventListener("input", () => {
      email.setCustomValidity("");
      email.removeAttribute("aria-invalid");
      form.classList.remove("has-error");
      if (form.classList.contains("is-success")) {
        form.classList.remove("is-success");
        status.hidden = true;
        status.textContent = "";
      }
    });

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      event.stopPropagation();

      email.value = email.value.trim();
      const errorMessage = form.dataset.errorMessage || "Introduce un correo electrónico válido.";
      const hasFullEmailDomain = window.babiiniIsFullEmail(email.value);
      email.setCustomValidity(hasFullEmailDomain ? "" : errorMessage);

      if (!hasFullEmailDomain || !form.checkValidity()) {
        const invalidControl = form.querySelector(":invalid") || email;
        invalidControl.setAttribute("aria-invalid", "true");
        form.classList.add("has-error");
        form.classList.remove("is-success");
        status.hidden = false;
        status.textContent = errorMessage;
        invalidControl.focus();
        form.reportValidity();
        return;
      }

      email.removeAttribute("aria-invalid");
      form.classList.remove("has-error", "is-success");
      status.hidden = false;
      status.textContent = form.dataset.loadingMessage || "Enviando…";
      if (submit) {
        submit.disabled = true;
        submit.setAttribute("aria-busy", "true");
      }

      try {
        if (window.Shopify?.shop) {
          const response = await fetch(contactUrl, {
            method: "POST",
            body: new FormData(form),
            credentials: "same-origin",
            headers: { "X-Requested-With": "XMLHttpRequest" },
          });
          if (!response.ok) throw new Error(`Newsletter request failed (${response.status})`);
        }

        form.classList.add("is-success");
        status.textContent = form.dataset.successMessage || "Gracias por suscribirte.";
        form.reset();
      } catch (_error) {
        form.classList.add("has-error");
        status.textContent = form.dataset.submitErrorMessage || "No pudimos completar la suscripción. Inténtalo de nuevo.";
      } finally {
        if (submit) {
          submit.disabled = false;
          submit.removeAttribute("aria-busy");
        }
      }
    }, true);
  };

  const initialize = () => {
    document.querySelectorAll(NEWSLETTER_SELECTOR).forEach(setupNewsletterForm);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
